"use client";

import React from "react";
import { ShieldCheck, Cpu, Gauge, ArrowUpRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
const specMetrics = [];
export default function Hero() {
  const shouldReduceMotion = useReducedMotion();
  const entranceAnimation = shouldReduceMotion ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 1,
    y: 0
  };
  const initialMotion = shouldReduceMotion ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 12
  };
  return <section id="hero" data-nav="light" className="relative w-full overflow-hidden border-b border-border bg-background pt-10 pb-16 md:pt-16 md:pb-24 lg:pt-20 lg:pb-28">
      {/* Structural Datum Lines */}
      <div className="pointer-events-none absolute inset-0 select-none">
        <div className="mx-auto h-full max-w-7xl border-x border-border/50 px-4 sm:px-6 lg:px-8">
          <div className="h-full w-full" />
        </div>
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8 items-center">
          {/* Text Specification Block */}
          <motion.div initial={initialMotion} animate={entranceAnimation} transition={{
          duration: 0.3,
          ease: [0.16, 1, 0.3, 1]
        }} className="lg:col-span-7 flex flex-col items-start">
            {/* Eyebrow spec badge */}
            <div className="mb-4 inline-flex items-center gap-2 rounded-none border border-border bg-muted px-3 py-1 text-xs font-mono font-medium tracking-wider text-foreground uppercase">
              <span className="inline-block size-1.5 bg-primary" />
              NEW MECHANICAL BULLS
            </div>

            {/* Display Heading */}
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-foreground leading-[1.05]">New Mechanical Bulls for Sale</h1>

            {/* Clean supporting subline */}
            <p className="mt-5 max-w-2xl font-sans text-base sm:text-lg text-muted-foreground leading-relaxed">If you're looking for a new mechanical bull for sale, start by comparing the actual machine, equipment package, price and available product information. Mechanical Bull Shop brings current new bull riding systems together with visible pricing and product-specific details so you can evaluate each machine before making an enquiry.</p>

            {/* Action Group */}
            <div className="mt-8 flex flex-wrap items-center gap-4 w-full sm:w-auto">
              <Button asChild className="h-12 rounded-none border border-primary bg-primary px-7 text-sm sm:text-base font-serif font-semibold uppercase tracking-wider text-primary-foreground transition-colors hover:bg-primary/90">
                <Link to="/RequestQuotePage">
                  Enquire About This Bull
                  <ArrowUpRight className="size-4 ml-1.5" />
                </Link>
              </Button>

              <Button asChild variant="outline" className="h-12 rounded-none border border-foreground bg-transparent px-7 text-sm sm:text-base font-serif font-semibold uppercase tracking-wider text-foreground transition-colors hover:bg-foreground hover:text-background">
                <Link to="/MechanicalBullPriceGuidePage">
                  View Price Guide
                </Link>
              </Button>
            </div>

            {/* Micro Industrial Spec Plate Strip */}
            <div className="mt-10 grid w-full grid-cols-1 sm:grid-cols-3 border border-border bg-muted/30">
              {specMetrics.map((item, i) => {
              const IconComponent = item.icon;
              return <div key={item.label} data-index={i} className="border-b sm:border-b-0 sm:border-r last:border-b-0 sm:last:border-r-0 border-border p-4 flex flex-col justify-between">
                    <div className="flex items-center gap-2 mb-2">
                      <IconComponent className="size-4 text-primary" />
                      <span className="font-mono text-xs uppercase tracking-wider text-muted-foreground">
                        {item.label}
                      </span>
                    </div>
                    <span className="font-sans text-xs sm:text-sm font-semibold text-foreground">
                      {item.value}
                    </span>
                  </div>;
            })}
            </div>
          </motion.div>

          {/* Machine Photo Spec Container */}
          <motion.div initial={initialMotion} animate={entranceAnimation} transition={{
          duration: 0.35,
          delay: 0.08,
          ease: [0.16, 1, 0.3, 1]
        }} className="lg:col-span-5">
            
          </motion.div>
        </div>
      </div>
    </section>;
}